import { css } from "styled-components";
import { Toast } from "drywall";
import { spaceMixin } from "../spaceMixin"; // Push the close button to the far right

var closeButtonCSS = function closeButtonCSS(props) {
  var closeButton = props.closeButton;

  if (!closeButton) {
    return "";
  }

  return css(["", "{margin-left:auto;}", ",", "{margin-right:", ";margin-left:0;}", "{margin-left:auto;}"], Toast.Icon, Toast.Action, Toast.Body, spaceMixin("sm")(props), Toast.Close);
};
/** @class BannerMixin */

/** @method */


export var BannerMixin = function BannerMixin(props) {
  return css(["display:flex;max-width:none;border-radius:0;box-shadow:none;justify-content:center;", ""], closeButtonCSS(props));
};